export const THEMES = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
  NATURE: 'NATURE',
} as const

export const COLORS = {
  GREEN: '#4caf50',
  JUNGLE_GREEN: '#01ab56',
  PURPLE: '#5664d2',
  RED: '#f44336',
  ORANGE: '#ff9800',
  WHITE: '#ffffff',
  LIGHT_GRAY: '#979CA4',
  SLATE_GRAY: '#6b778c',
  CHARCOAL_GRAY: 'rgb(30, 32, 33)',
  DIM_WHITE: '#f0f0f0',
  GRAY_BLUE: '#26323F',
  DEEP_OCEAN: '#172b4d',
  STEEL_BLUE: '#42526e',
  SLATE_BLUE: '#919eab',
  LIGHT_BLUE: '#94C7F0',
  FADED_STEEL_BLUE: 'rgba(145, 158, 171, 0.24)',
  CHARCOAL: '#141B22',
  JET_BLACK: '#161616',
  BRIGHT_YELLOW: '#FFD600',
  DIM_YELLOW: '#EDBD00',
  GRADIENT_BG: 'linear-gradient(180deg, #313E4B 0%, #1F2934 100%)',
  NERO: '#202020',
} as const

export const FONTS = {
  PRIMARY_TEXT:
    'Public Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
  CIRCULAR_STD_MEDIUM: "'Circular Std Medium', sans-serif",
  INTER: "'Inter', sans-serif",
} as const
